import app from 'flarum/forum/app';
export { default as extend } from './extend';
import PtbDiscussionBumped from './Post/PtbDiscussionBumped';
import PtvRequiresPayment from './Post/PtvRequiresPayment';
import Discussion from './../common/Discussion';
import Tag from './../common/Tag';
import PayToBump from './Discussion/PayToBump';
import PayToPost from './Discussion/PayToPost';
import PayToPostComposerNotice from './Discussion/PayToPostComposerNotice';
import Bounty from './Discussion/Bounty';
import PayToView from './Discussion/PayToView';
import AddNavItem from './addNavItem';
app.initializers.add('floxum-payments', () => {
  Discussion();
  Tag();
  app.postComponents.ptbDiscussionBumped = PtbDiscussionBumped;
  app.postComponents.ptvRequiresPayment = PtvRequiresPayment;
  PayToBump();
  PayToPost();
  PayToPostComposerNotice();
  Bounty();
  PayToView();
  AddNavItem();
});